import { useEditor, useNode } from "@craftjs/core";
import { Grid } from "@mui/material";
import SettingsItemText from "../../../../components/Viewport/components/Sidebar/components/Settings/components/SettingsItemText";
import SettingsSection from "../../../../components/Viewport/components/Sidebar/components/Settings/components/SettingsSection";

const Settings = () => {
    const { id } = useNode();
    const { displayName, actions } = useEditor((state) => ({
        displayName:
            state.nodes[id] && state.nodes[id].data.custom.displayName
                ? state.nodes[id].data.custom.displayName
                : state.nodes[id].data.displayName,
    }));

    return (
        <>
            <SettingsSection
                title="Identification"
                summary={() => {
                    return `${displayName || "-"}`;
                }}
            >
                <Grid size={{ xs: 12 }}>
                    <SettingsItemText
                        type={"text"}
                        value={displayName}
                        onChange={(value: string) => {
                            actions.setCustom(id, (custom) => (custom.displayName = value));
                        }}
                        fullWidth={true}
                        label="Display name"
                    />
                </Grid>
            </SettingsSection>
        </>
    );
};

export default Settings;
